import { Controller } from "@hotwired/stimulus"

// Provides datalist-style autocomplete suggestions for tags
export default class extends Controller {
  static targets = ["input", "datalist"]
  static values = { url: String }

  search() {
    const term = this.inputTarget.value.trim()
    if (term.length < 2) return

    const url = `${this.urlValue}?q=${encodeURIComponent(term)}`

    fetch(url, { headers: { "Accept": "application/json" } })
      .then((response) => response.json())
      .then((data) => this.populate(data.tags || []))
      .catch(() => {
        // swallow errors to avoid noisy UI
      })
  }

  populate(tags) {
    if (!this.hasDatalistTarget) return
    this.datalistTarget.innerHTML = ""
    tags.forEach((tag) => {
      const option = document.createElement("option")
      option.value = tag
      this.datalistTarget.appendChild(option)
    })
  }
}
